module.exports = __webpack_public_path__ + "name=img/src/assets/projects/code/contentoffice/2.png?81e101894413ea6429ffa5f001e181d7";